export const jobPreventedFromInvoicingBy = ({ value, xeroContactId }) => {
  const errors = [
    value ? null : 'No Line Items.',
    xeroContactId ? null : 'No Xero Contact.',
  ].filter(Boolean)

  return errors
}
